<template>
    <div class="user-profile" v-if="currentCustomer">
        <div class="main-profile">
            <div class="centered">
                <div class="aside-responsive x-scroll">
                    <p @click="ChangeProfile(1)" class="pointer aside-responsive-content"><i class="fas fa-circle" :class="{ 'profile-inactive' : prof===1 ? true:false }"></i>Editar mi perfil</p>
                    <p @click="ChangeProfile(2)" class="pointer aside-responsive-content"><i class="fas fa-circle" :class="{ 'profile-inactive' : prof===2 ? true:false }"></i>Mis órdenes</p>
                    <p @click="ChangeProfile(3)" class="pointer aside-responsive-content"><i class="fas fa-circle" :class="{ 'profile-inactive' : prof===3 ? true:false }"></i>Mi botiquín</p>
                    <p @click="ChangeProfile(4)" class="pointer aside-responsive-content"><i class="fas fa-circle" :class="{ 'profile-inactive' : prof===4 ? true:false }"></i>Mis direcciones</p>
                    <p @click="ChangeProfile(5)" class="pointer aside-responsive-content"><i class="fas fa-circle" :class="{ 'profile-inactive' : prof===5 ? true:false }"></i>Centro de ayuda</p>
                </div>
                <form action class="profile" v-if="prof===1" @submit.prevent="EditCustomer">
                    <h2 class="form-title">Editar mi perfil</h2>
                    <input type="text" name="name" id="name" class="profile-control left" placeholder="Nombre" :value="currentCustomer.firstName"/>
                    <input type="text" name="lastName" id="lastName" class="profile-control left" placeholder="Apellidos" :value="currentCustomer.lastName"/>
                    <input type="text" onfocus="(this.type='date')" format="dd/mm/aaaa" name="birthday" id="birthday" class="profile-control left" placeholder="Fecha de nacimiento"  data-date-inline-picker="true" />
                    <input type="text" name="phone"  id="phone" class="profile-control left" placeholder="Telefono" :value="GetPhone('LANDLINE',currentCustomer.phones)"/>
                    <input type="text" name="mobile" id="mobile" class="profile-control left" placeholder="Celular" :value="GetPhone('MOBILE',currentCustomer.phones)"/>
                    <input type="text" name="email"  id="email" class="profile-control left" placeholder="Correo electronico" :value="currentCustomer.email"/>
                    <input type="password" name="password" id="password" class="profile-control left" placeholder="Contraseña" />
                    <input type="password" name="passwordConfirmation" id="passwordConfirmation" class="profile-control left" placeholder="Confirmar contraseña" />
                    <div class="mid-container">
                        <button type="submit" class="ui blue button wide">Actualizar datos</button>
                        <button type="button" class="ui default button wide">Cerrar sesión</button>
                    </div>
                </form>
                <div class="profile" v-if="prof===2">
                    <div style="margin:auto">
                        <h2 class="form-title">Mis órdenes</h2>
                    </div>
                    <div v-if="userOrders">
                    <div>
                    <div v-for="(data,index) in userOrders" :key="index">
                    <div v-if="data.status!=='COMPLETED' && data.status!=='CANCELED'">
                        <p class="left" >{{data.translatedStatus}}</p>
                        
                        <div class="info-table-header">
                            <div style="display:flex;" class="space-between">
                                <h3>Orden #{{data.number}}</h3>
                                <div style="display:flex;">
                                    <p style="margin-top:0.7em">{{data.products.length}} producto</p>
                                    <h3 style="padding-right:.5rem">Total: {{orderTotals.total + orderTotals.discounts  | to-currency-from-cents}}</h3>
                                </div>
                            </div>
                        </div>
                        <!-- Contains the stepper variables -->
                        <div style="overflow-x:auto;">
                            <div class="md-stepper-horizontal">
                                <div class="md-step" :class="{ active: CheckActive({key:'created',value:data.status}) , done: CheckDone({key:'created',value:data.status}) > 1? true:false, current: false}">
                                    <div class="md-step-circle">
                                        <span v-if="1 < CheckDone({key:'created',value:data.status})"><i class="fas fa-check"></i></span>
                                        <span v-else class="transparent">1</span>
                                    </div>
                                    <div class="md-step-title">Creada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: CheckActive({key:'packed',value:data.status}) , done: CheckDone({key:'packed',value:data.status}) > 2? true:false, current: false}">
                                    <div class="md-step-circle">
                                        <span v-if="2 < CheckDone({key:'packed',value:data.status})"><i class="fas fa-check"></i></span>
                                        <span v-else class="transparent">2</span>
                                    </div>
                                    <div class="md-step-title">Empacada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: CheckActive({key:'send',value:data.status}) , done: CheckDone({key:'send',value:data.status}) > 3? true:false, current: false }">
                                    <div class="md-step-circle">
                                        <span v-if="3 < CheckDone({key:'send',value:data.status})"><i class="fas fa-check"></i></span>
                                        <span v-else class="transparent">3</span>
                                    </div>
                                    <div class="md-step-title">En camino</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: CheckActive({key:'complete',value:data.status}) , done: CheckDone({key:'complete',value:data.status}) == 4? true:false, current: false }">
                                    <div class="md-step-circle">
                                        <span v-if="4 === CheckDone({key:'complete',value:data.status}) "> <i class="fas fa-check"></i> </span>
                                        <span v-else class="transparent">4</span>
                                    </div>
                                    <div class="md-step-title">Entregada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                            </div>
                        </div>
                        <div class="product-slider">
                            <div class="items">
                                <div class="slider-grid">
                                    <hooper :itemsToShow="4" ref="hooper">
                                        <slide v-for="(product,index) in data.products " :key="index">
                                            <div class="my-medicine">
                                                <div  class="box-product columns space-around product-hover-card center"  style="width:auto;height:auto" @click="GetProductBySlug(product.slug)">
                                                     <img  onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="product.name" :src="'https://images.gofarma.com.mx/'+product.sku+'-1.jpeg'">
                                                    <div class="parent-container">
                                                        <div class="container">
                                                            <p class="product-name">{{product.name}}</p>
                                                        </div>
                                                    </div>
                                                    <!--<span v-if="hoverIndex===index" class="gofarma-bg-aqua" >Agregar al Carrito</span>-->
                                                </div>
                                            </div>
                                        </slide>
                                        <hooper-navigation slot="hooper-addons"></hooper-navigation>
                                    </hooper>
                                </div>
                                <div class="buttons-grid">
                                    <button class="ui default button wide">Cancelar</button>
                                    <button class="ui blue button wide">Volver a surtir</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    <div>
                    <div v-for="(data,index) in userOrders" :key="index">
                    <div v-if="data.status=='COMPLETED'">
                        <p class="left" >{{data.translatedStatus}}</p>
                        <div class="info-table-header">
                            <div style="display:flex;" class="space-between">
                                <h3>Orden #{{data.number}}</h3>
                                <div style="display:flex;">
                                    <p style="margin-top:0.7em">{{data.products.length}} producto</p>
                                    <h3 style="padding-right:.5rem">Total: ${{data.orderTotal}}</h3>
                                </div>
                            </div>
                        </div>
                        <!-- Contains the stepper variables -->
                        <div style="overflow-x:auto;">
                            <div class="md-stepper-horizontal">
                                <div class="md-step" :class="{ active: CheckActive({key:'created',value:data.status}) , done: CheckDone({key:'created',value:data.status}) > 1? true:false, current: false}">
                                    <div class="md-step-circle">
                                        <span v-if="1 < CheckDone({key:'created',value:data.status})"><i class="fas fa-check"></i></span>
                                        <span v-else class="transparent"></span>
                                    </div>
                                    <div class="md-step-title">Creada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: CheckActive({key:'packed',value:data.status}) , done: CheckDone({key:'packed',value:data.status}) > 2? true:false, current: false}">
                                    <div class="md-step-circle">
                                        <span v-if="2 < CheckDone({key:'packed',value:data.status})"><i class="fas fa-check"></i></span>
                                        <span v-else class="transparent">2</span>
                                    </div>
                                    <div class="md-step-title">Empacada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: CheckActive({key:'send',value:data.status}) , done: CheckDone({key:'send',value:data.status}) > 3? true:false, current: false }">
                                    <div class="md-step-circle">
                                        <span v-if="3 < CheckDone({key:'send',value:data.status})"><i class="fas fa-check"></i></span>
                                        <span v-else class="transparent">3</span>
                                    </div>
                                    <div class="md-step-title">En camino</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: CheckActive({key:'complete',value:data.status}) , done: CheckDone({key:'complete',value:data.status}) == 4? true:false, current: false }">
                                    <div class="md-step-circle">
                                        <span v-if="4 === CheckDone({key:'complete',value:data.status}) "> <i class="fas fa-check"></i> </span>
                                        <span v-else class="transparent">4</span>
                                    </div>
                                    <div class="md-step-title">Entregada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                            </div>
                        </div>
                        <div class="product-slider">
                            <div class="items">
                                <div class="slider-grid">
                                    <hooper :itemsToShow="4" ref="hooper">
                                        <slide v-for="(product,index) in data.products " :key="index">
                                            <div class="my-medicine">
                                                <router-link  class="box-product columns space-around product-hover-card center" :to="{ name: 'detalle', params: {slug:product.slug } }" style="width:auto;height:auto">
                                                     <img  onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="product.name" :src="'https://images.gofarma.com.mx/'+product.sku+'-1.jpeg'">
                                                    <div class="parent-container">
                                                        <div class="container">
                                                            <p class="product-name">{{product.name}}</p>
                                                        </div>
                                                    </div>
                                                    <!--<span v-if="hoverIndex===index" class="gofarma-bg-aqua" >Agregar al Carrito</span>-->
                                                </router-link>
                                            </div>
                                        </slide>
                                        <hooper-navigation slot="hooper-addons"></hooper-navigation>
                                    </hooper>
                                </div>
                                <div class="buttons-grid">
                                    <button class="ui blue button wide">Volver a surtir</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    <div>
                    <div v-for="(data,index) in userOrders" :key="index">
                    <div v-if="data.status=='CANCELED'">
                        
                        <p class="left" >{{data.translatedStatus}}</p>
                        <div class="info-table-header">
                            <div style="display:flex;" class="space-between">
                                <h3>Orden #{{data.number}}</h3>
                                <div style="display:flex;">
                                    <p style="margin-top:0.7em">{{data.products.length}} producto</p>
                                    <h3 style="padding-right:.5rem">Total: ${{data.orderTotal}}</h3>
                                </div>
                            </div>
                        </div>
                        <!-- Contains the stepper variables -->
                        <div style="overflow-x:auto;">
                            <div class="md-stepper-horizontal">
                                <div class="md-step" :class="{ active: false , done: false, current: false}">
                                    <div class="md-step-circle">
                                        <span class="transparent">1</span>
                                    </div>
                                    <div class="md-step-title">Creada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: false , done: false, current: false}">
                                    <div class="md-step-circle">
                                        <span class="transparent">2</span>
                                    </div>
                                    <div class="md-step-title">Empacada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: false , done: false, current: false}">
                                    <div class="md-step-circle">
                                        <span class="transparent">3</span>
                                    </div>
                                    <div class="md-step-title">En camino</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                                <div class="md-step" :class="{ active: true , done: false, current: false}">
                                    <div class="md-step-circle-canceled">
                                        <span class="transparent">4</span>
                                    </div>
                                    <div class="md-step-title">Cancelada</div>
                                    <div class="md-step-bar-left"></div>
                                    <div class="md-step-bar-right"></div>
                                </div>
                            </div>
                        </div>
                        <div class="product-slider">
                            <div class="items">
                                <div class="slider-grid">
                                    <hooper :itemsToShow="4" ref="hooper">
                                        <slide v-for="(product,index) in data.products " :key="index">
                                            <div class="my-medicine">
                                                <div  class="box-product columns space-around product-hover-card center"  style="width:auto;height:auto" @click="GetProductBySlug(product.slug)">
                                                     <img  onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="product.name" :src="'https://images.gofarma.com.mx/'+product.sku+'-1.jpeg'">
                                                    <div class="parent-container">
                                                        <div class="container">
                                                            <p class="product-name">{{product.name}}</p>
                                                        </div>
                                                    </div>
                                                    <!--<span v-if="hoverIndex===index" class="gofarma-bg-aqua" >Agregar al Carrito</span>-->
                                                </div>
                                            </div>
                                        </slide>
                                        <hooper-navigation slot="hooper-addons"></hooper-navigation>
                                    </hooper>
                                </div>
                                <div class="buttons-grid">
                                    <button class="ui blue button wide">Volver a surtir</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    <div v-else>
                        Aun no se registra ninguna orden
                    </div>
                </div>

                <div class="profile" v-if="prof===3">
                    <h2 class="form-title">Mi botiquín</h2>
                    <div class="product-sub-header-info-align" v-if="userFavorites">
                        <p class="left" >{{userFavorites.length}} productos</p>
                        <div class="product-header-filer">
                            <select name="orderBy" id="orderBy" class="form-control">
                                <option value selected disabled>Ordenar por</option>
                            </select>
                        </div>
                    </div>
                    <div class="products-grid row wrap"  v-if="userFavorites">
                        <div v-for="(data,index) in userFavorites" :key="index"  @mouseover="HoverIndex(index)" class="box-product columns space-around product-hover-card">
                            <div class="pointer" @click="GetProductBySlug(data.product.slug)">
                                <div>
                                    <img onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="data.product.name" :src="'https://images.gofarma.com.mx/'+data.product.sku+'-1.jpeg'" />
                                </div>
                                <div class="container">
                                    <p class="product-name">{{data.product.name}}</p>
                                </div>
                                <div class="product-info">
                                    <div>
                                        <span class="cost">${{data.product.basePrice | numeral('0.00')}}</span>
                                    </div>
                                    <span class="discount-cost">${{data.product.lowerIndividualPriceForWeb | numeral('0.00')}}</span>
                                    <span class="today-only">SOLO HOY</span>
                                </div>
                                <!--<span v-if="hoverIndex===index" class="gofarma-bg-aqua" >Agregar al Carrito</span>-->
                            </div>
                             <span v-if="hoverIndex===index" class="gofarma-bg-aqua pointer" @click="DeleteToFavorite(data.id)">Eliminar de mi botiquín</span>
                        </div>
                    </div>
                </div>
                <div v-if="prof===4">
                    <Addresses/>
                </div>
                <form class="profile" v-if="prof===5" @submit.prevent="SubmitComments($event)">
                    <h2 class="form-title">Centro de ayuda</h2>
                    <select name="type" id="type" class="form-control left" @change="ChangeType($event)">
                        <option value="-1" selected disabled>Seleccione un tipo</option>
                        <option value="0">Sugerencia</option>
                        <option value="1">Solicitud</option>
                    </select>
                    <!-- suggestion -->
                    <select v-if="type!==-1" name="suggestionType" id="suggestionType" class="form-control left" @change="ChangeSuggestionType($event)">
                        <option value="0">De mi pedido</option>
                        <option value="1">De la pagina</option>
                        <option value="2">Del repartidor</option>
                        <option value="3">Del servicio</option>
                        <option value="4">De facturacion</option>
                        <option value="5">Otro</option>
                    </select>

                    <div v-if="suggestionType == 0 || suggestionType == 2 || suggestionType == 4">
                        <input type="number" class="form-control left" required name="orderNumber" id="orderNumber" placeholder="Ingrese el numero de orden" />
                    </div>
                    <input type="text" class="form-control left" required name="name" id="name" placeholder="Nombre" />
                    <input type="email" class="form-control left" required name="email" id="email" placeholder="Correo electronico" />
                    <textarea cols="30" rows="10" class="form-control left" name="description" id="description" placeholder="Descripción"></textarea>
                    <select name="type" id="type" class="form-control left">
                        <option value selected disabled>¿Desea recibir respuesta a su mensaje?</option>
                        <option value>Si</option>
                        <option value>No</option>
                    </select>
                    <!--suggestion-->

                    <div class="mid-container">
                        <input class="ui blue button wide" type="submit" value="Enviar" />
                    </div>
                </form>
            </div>
        </div>
        <div class="aside-profile">
            <p @click="ChangeProfile(1)" class="pointer">
                <i class="fas fa-circle" :class="{ 'profile-inactive' : prof===1 ? true:false }"></i>Editar mi perfil
            </p>
            <p @click="ChangeProfile(2)" class="pointer">
                <i class="fas fa-circle" :class="{ 'profile-inactive' : prof===2 ? true:false }"></i>Mis órdenes
            </p>
            <p @click="ChangeProfile(3)" class="pointer">
                <i class="fas fa-circle" :class="{ 'profile-inactive' : prof===3 ? true:false }"></i>Mi botiquín
            </p>
            <p @click="ChangeProfile(4)" class="pointer">
                <i class="fas fa-circle" :class="{ 'profile-inactive' : prof===4 ? true:false }"></i>Mis direcciones
            </p>
            <p @click="ChangeProfile(5)" class="pointer">
                <i class="fas fa-circle" :class="{ 'profile-inactive' : prof===5 ? true:false }"></i>Centro de ayuda
            </p>
        </div>
    </div>
</template>

<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAgXYwmEyjyrfh05bQvYAchiB33tLDAIQ8"></script>
<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import { mapState, mapActions } from "vuex";
import Addresses from '../components/Addresses'
export default {
  name: "userProfile",
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    Addresses
  },
  data() {
    return {
      type: -1,
      suggestionType: 0
    };
  },
  beforeMount(){
      if(this.currentCustomer){
            this.GetFavorites()
            this.GetUserAddresses()
            this.GetUserOrders()
      }else{
            this.RouterPush('/identificarse')
      }
     
  },
  methods: {
    ChangeProfile(profile) {
        let prof = profile
        this.$store.commit('StateAssign',{prof})
    },
    ChangeType(e) {
        this.type = e.target.value
    },
    ChangeSuggestionType(e) {
        this.suggestionType = e.target.value
    },
    DeleteAddress(){
        let addressId = document.querySelector("[data-address-id]").dataset.addressId
        this.$store.dispatch('DeleteAddress',addressId)
    },
     HoverIndex(index){
            let hoverIndex = index
            this.$store.commit('StateAssign',{hoverIndex})
    },
    CheckActive(obj){
        let response = false
        switch(obj.key){
            case 'created':
                if(obj.value=='NEW') response = true
            break    
            case 'packed':
                if(obj.value==('PACKED'||'UNKNOWN'||'PRECOMPLETED'||'UNPAID'||'UNDELIVERED'||'PENDING'||'WAITING_FOR_ADVANCE'||'ADVANCE_PICKED'||'ADVANCE_NOT_PICKED')) response = true
            break 
            case 'send':
                if(obj.value==('SENT'||'COLLECTED'||'DELIVERED'||'RESENT')) response = true
            break 
            case 'complete':
                if(obj.value=='COMPLETED') response = true
            break
        }
        return response
    },
    GetPhone(key, phones){
        let phone = null
        phones.forEach(element => {
            if(element.phoneType===key){
                phone = element.value
            }
        });
        return phone
    },
    CheckDone(obj){
        let response = 5
          switch(obj.key){
            case 'created':
                if(obj.value=='NEW') response = 1
            break    
            case 'packed':
                if(obj.value==('PACKED'||'UNKNOWN'||'PRECOMPLETED'||'UNPAID'||'UNDELIVERED'||'PENDING'||'WAITING_FOR_ADVANCE'||'ADVANCE_PICKED'||'ADVANCE_NOT_PICKED'))response = 2
            break 
            case 'send':
                if(obj.value==('SEND'||'COLLECTED'||'DELIVERED'||'RESENT'))response = 3 
            break 
            case 'complete':
                if(obj.value=='COMPLETED') response = 4
            break
        }
        return response
    },
    ...mapActions(['SubmitComments','EditCustomer','EditAddress','GetUserAddresses','DeleteAddress','GetUserOrders','GetFavorites','DeleteToFavorite','RouterPush','GetProductBySlug'])
  },
  computed: {
    ...mapState([
      'filterProducts',
      'hoverIndex',
      'category',
      'component',
      'restriction',
      'currentCustomerAddresses',
      'currentCustomer',
      'userFavorites',
      'userOrders',
      'hoverIndex',
      'prof',
      'orderTotals'
    ])
  }
};
</script>

<style scoped>

.fa-check {
  color: #fafafa;
}

.column-space {
  margin-bottom: 1rem;
  width: 30%;
}

.user-profile {
  display: flex;
  flex-flow: row-reverse wrap;
  margin: auto;
}
.profile-inactive {
  color: var(--light-blue);
}
.main-profile,
.aside-profile {
  flex: 0 100%;
  height: auto;
}
.main-profile {
  justify-content: center;
  width: 100%;
}
@media (min-width: 600px) {
  .main-profile {
    flex: 1 0 0px;
    height: auto;
  }
  .aside-profile {
    flex: 0 0 200px;
    height: auto;
    text-align: left;
    padding-left: 20px;
  }
}


.info-table-header {
  width: 100%;
  text-align: left;
  background-color: rgb(243, 243, 243);
}

.info-table-header h3 {
  margin: 0.5rem 0rem 0.5rem 2rem;
}

.product-slider {
  width: 100%;
  height: auto;
  border-top: none;
  border-left: 0.01rem solid rgb(243, 243, 243);
  border-bottom: 0.01rem solid rgb(243, 243, 243);
  border-right: 0.01rem solid rgb(243, 243, 243);
}

.items {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  grid-gap: 10px;
  padding: 10px;
}

.slider-grid {
  grid-area: 1/1/5/6;
  padding-bottom: 0.625rem;
}

.buttons-grid {
  grid-area: 3/6/4/7;
}
.hooper {
  height: auto;
}

@media screen and (max-width: 1611px) {
  .items {
    display: inherit !important;
  }
}


@media (max-width:46.9375rem){
    .aside-profile{
        display: none;
    }  

    .aside-responsive{
        text-align:left;
        display: flex;
    }  
}
</style>